export default __webpack_public_path__ + "static/media/choose-where.1610592f.svg";